import {Injectable} from '@angular/core';
import {ApiService} from '../api.service';
import {Observable} from 'rxjs';
import {Organization, ManageOrganization} from './models/organization.model';

@Injectable({
  providedIn: 'root'
})
export class OrganizationsService {

  constructor(
    private readonly apiService: ApiService
  ) {
  }

  public getOrganizations(): Observable<any> {
    return this.apiService.get(`/organizations/all`);
  }

  public getCurrentOrganization(): Observable<Organization> {
    return this.apiService.get(`/organizations/current`);
  }

  public getOrganization(organizationId: number): Observable<Organization> {
    return this.apiService.get(`/organizations/${organizationId}`);
  }

  public createOrganization(data: ManageOrganization): Observable<Organization> {
    return this.apiService.post(`/organizations`, data);
  }

  public updateOrganization(id: number, data: ManageOrganization): Observable<Organization> {
    return this.apiService.put(`/organizations/${id}`, data);
  }

  public changeOrganization(data): Observable<any> {
    return this.apiService.put(`/auth/organizations/change`, data);
  }

  public deleteOrganization(organizationId: number): Observable<Organization> {
    return this.apiService.delete(`/organizations/${organizationId}`);
  }

  public validateDns(dns: string) {
    return this.apiService.get(`/organizations/dns/${dns}`);
  }
}
